<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">
      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Publish a Scorm
        </v-card-title>

        <v-card-subtitle class="white--text">
          Add details below
        </v-card-subtitle>
      </div>
      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          SCORM Details
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Add SCORM Details
                  </v-card-title>

                  <div class="pa-3">
                    <v-card-title>
                      Add SCORM File
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-file-input
                            show-size
                            label="Select a SCORM .zip file"
                            accept=".zip"
                            placeholder="Select a SCORM .zip file"
                            persistent-hint
                            hint="1. Must be a .zip file. 2. Must be a valid SCORM package."
                            solo
                            flat
                            v-model="add.file"
                            style="width: 100%"
                            height="150"
                            class="mb-5"
                        ></v-file-input>
                      </v-row>
                      <v-row
                          v-if="scormCourseApiError && scormCourseApiError.fields && scormCourseApiError.fields.file">
                        <p class="error--text">
                          SCORM file must be chosen.
                        </p>
                      </v-row>

                      <v-row>
                        <v-card-title>
                          Add Course ID
                        </v-card-title>
                      </v-row>

                      <v-row>
                        <v-text-field
                            v-model="add.courseId"
                            label="Scorm Course Reference"
                            solo
                            filled
                            flat
                            hint="Scorm Course Reference"
                            prepend-icon="mdi-identifier"
                        ></v-text-field>
                      </v-row>

                      <v-row
                          v-if="scormCourseApiError && scormCourseApiError.fields && scormCourseApiError.fields.description">
                        <p class="error--text">
                          A SCORM course should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row v-if="scormCourseApiError">
                        <p class="error--text">Errors in submission, please review the form.</p>
                      </v-row>

                    </v-card-text>
                  </div>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">

          <Loading  v-if="scormCourseItemLoading" />

          <ConfirmCancelButtons
              :item="add"
              confirm-text="Create Scorm"
              :confirm-action="addItemConfirm"
              :cancel-action="closeDialog"
              :confirm-disabled="scormCourseItemLoading"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->

    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import Loading from "@/components/common/Loading";

export default {
  name: "ScormAdd",
  components: {
    Loading, ConfirmCancelButtons,
  },
  data() {
    return {
      scormCourse: {},
      add: {
        courseId: '',
        file: undefined,
      },
    };
  },
  computed: {
    ...mapGetters(['scormCourseApiError', 'openDialog', 'scormCourseItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'scormAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addScormCourse', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.add = {
        courseId: '',
        file: undefined,
      };
    },
    async addItemConfirm() {
      const added = await this.addScormCourse(this.add);

      if (added) {
        this.closeOpenDialog();
        this.add = {
          courseId: '',
          file: undefined,
        };
      }
    },
  },
};
</script>
